import { render } from "./bike_head_mobile.vue?vue&type=template&id=246885cc"
import script from "./bike_head_mobile.vue?vue&type=script&lang=js"
export * from "./bike_head_mobile.vue?vue&type=script&lang=js"

import exportComponent from "/home/newbaidev/public_html/projects-sit/uae/sit-ae-car.new.baidev.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__